import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from './Login/LoginPage';
import DashboardPage from './Dashboard/dashboard';
import BannerForm from './BannerForm/BannerForm';
import CandidateTestimonyForm from './CandidateTestimonyForm/CandidateTestimony';
import ImpactNumbersForm from './ImpactNumberForm/Impactnumber';
import CurrentOpeningsForm from './CurrentOpeningsForm/CurrentOpeningsForm';
import UserForm from './Users/Users';

function BaseAdmin() {
    const isLoggedIn = localStorage.getItem("token"); 

    return (
            <Routes>
              <Route path="/" element={isLoggedIn ? <Navigate to="/admin/dashboard" /> : <LoginPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="banner-config" element={<BannerForm />} />
              <Route path="candidate-testimony-config" element={<CandidateTestimonyForm />} />
              <Route path="impact-number" element={<ImpactNumbersForm />} />
              <Route path="current-openings" element={<CurrentOpeningsForm />} />
              <Route path="users" element={<UserForm />} />
            </Routes>
    );

}


export default BaseAdmin;